import type { PipeTransform } from '@angular/core';
import { inject, Pipe } from '@angular/core';
import { LanguageService } from '@core/auth/services/language.service';

@Pipe({
  name: 'localDate',
  standalone: true
})
export class LocalDatePipe implements PipeTransform {
  private languageService = inject(LanguageService);

  transform(value: string | Date | null | undefined, _languageVersion?: number): string {
    return this.languageService.formatDate(value);
  }
}
